export default __webpack_public_path__ + "static/weekly-introduction-4ff867e836064666ef9792a7316ad55e.svg";